import { InvoiceFormConfig } from '../types';
import {
	laborConfig,
	partsConfig,
	equipmentConfig,
	travelConfig,
	freightConfig,
	miscellaneousConfig,
} from '../../SupplierInvoiceFormNew/CostSectionConfigs';
import { getInvoiceNumberBuyer, fetchTaxLineItemsForBuyer } from '../../../thunks/invoices_thunks';

export const createBuyerInvoiceConfig = (
	formData: any,
	workOrder: any,
	currentUser: any,
	history: any,
	onSubmit: (values: any, formInstance: any, scope: string) => Promise<any>,
	options?: {
		redirectForwardUrl?: string;
		creating?: boolean;
		updating?: boolean;
		createErrors?: string[];
		updateErrors?: string[];
		onSuccess?: (record: any) => void;
		onError?: (error: any) => void;
		onReset?: () => void;
		hasQuote?: boolean;
		parsedDataSnapshot?: any;
		disableCosts?: boolean;
		fetchTaxLineItems?: (currencyId: string) => Promise<any[]>;
	}
): InvoiceFormConfig => {
	return {
		formType: 'buyerInvoice',
		fields: {
			scope: true,
			invoiceNumber: true,
			externalWorkOrderId: true,
			invoiceDate: true,
			paymentTerms: true,
			dueDate: true,
			fileAttachments: false,
			status: true, // Show pending/paid radio
		},
		lineItemSections: [
			{ type: 'labor', show: true, config: laborConfig },
			{ type: 'parts', show: true, config: partsConfig },
			{ type: 'equipment', show: true, config: equipmentConfig },
			{ type: 'travel', show: true, config: travelConfig },
			{ type: 'freight', show: true, config: freightConfig },
			{ type: 'misc', show: true, config: miscellaneousConfig },
		],
		tax: {
			type: 'lineItems',
			// When currency is CAD, fetch GST/PST (or other) line items and show them
			fetchTaxLineItems:
				options && options.fetchTaxLineItems ? options.fetchTaxLineItems : undefined,
		},
		currency: {
			fetchInternally: true,
			source: options && options.hasQuote ? 'quote' : 'supplierFacility',
		},
		onSubmit,
		validateInvoiceNumber: async (value: string, supplierFacilityId?: string) => {
			return getInvoiceNumberBuyer(value, supplierFacilityId) as any;
		},
		formData,
		workOrder,
		currentUser,
		history,
		parsedDataSnapshot: options && options.parsedDataSnapshot,
		redirectForwardUrl: options && options.redirectForwardUrl,
		creating: options && options.creating,
		updating: options && options.updating,
		createErrors: options && options.createErrors,
		updateErrors: options && options.updateErrors,
		onSuccess: options && options.onSuccess,
		onError: options && options.onError,
		onReset: options && options.onReset,
		disableCosts: options && options.disableCosts,
	};
};
